//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    type: {
      type: String,
      default: 'view',
    },
    value: {
      type: Array,
      default: () => [],
    },
    ruleLength: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      types: {
        package: '包名',
        service: '服务名',
        method: '方法名',
        platform: '客户端类型',
      },
      operators: {
        in: '等于',
        contain: '包含',
      },
    };
  },
  methods: {
    changeType(val, index) {
      const arr = JSON.parse(JSON.stringify(this.value));
      arr[index].type = val;
      this.$emit('input', arr);
    },
    changeOperator(val, index) {
      const arr = JSON.parse(JSON.stringify(this.value));
      arr[index].operator = val;
      this.$emit('input', arr);
    },
    changeVal(val, index) {
      const arr = JSON.parse(JSON.stringify(this.value));
      arr[index].val = val;
      this.$emit('input', arr);
    },
    del(index) {
      const arr = JSON.parse(JSON.stringify(this.value));
      arr.splice(index, 1);
      this.$emit('input', arr);
    },
    add() {
      const arr = JSON.parse(JSON.stringify(this.value));
      this.$emit('input', [
        ...arr,
        {
          type: '',
          operator: '',
          val: '',
        },
      ]);
    },
    edit() {
      this.$emit('edit');
    },
    delRule() {
      this.$emit('del');
    },
  },
};
